// request-builder.js
import payloadBuilder from '@/utils/payload-builder.utilities.js'

export function requestBuilder() {
  async function executePayload(
    endpoint,
    requestName,
    {
      store = {},
      requestType,
      payloadType,
      payloads,
      conditions,
      excludeKeys,
      config,
      page,
      limit,
      sort,
      key,
    } = {}
  ) {
    const payload = await payloadBuilder(requestName, requestType)

    if (payloadType && payloads !== undefined) {
      payload.addPayload(payloadType, payloads)
    }

    if (conditions) {
      payload.addPayload('conditions', conditions)
    }

    if (excludeKeys && payloads !== undefined) {
      payload.deletePayload(payloads, excludeKeys)
    }

    if (page !== undefined) payload.addPayload('page', page)
    if (limit !== undefined) payload.addPayload('limit', limit)
    if (sort !== undefined) payload.addPayload('sort', sort)
    if (key !== undefined) payload.addPayload('key', key)

    return await payload.execute(endpoint, config, store)
  }



  async function getAllRecords(endpoint, requestName,requestType='all', store) {
    return await executePayload(endpoint, requestName, { store, requestType:requestType})
  }

  async function getRecords(endpoint, requestName, { store = {}, conditions, pagination = {},type, config } = {}) {
     return await executePayload(
      endpoint,
      requestName,
      {
        store,
        requestType: type || 'list',
        payloadType: conditions ? 'conditions' : undefined,
        payloads: conditions,
        page: pagination.page,
        limit: pagination.limit,
        sort: pagination.sort,
        key: pagination.key,
        config
      }
    )
  }


  async function getRecord(endpoint, requestName, { store = {}, conditions, config } = {}) {
    if (!conditions) {
      console.warn("getRecord: 'conditions' payload is highly recommended for single record retrieval.");
    }
    return await executePayload(
      endpoint,
      requestName,
      {
        store,
        requestType: 'get',
        payloadType: 'conditions',
        payloads: conditions,
        config
      }
    )
  }

  async function addRecord(endpoint, requestName, { store = {}, values,type='add', excludeKeys, config } = {}) {
    if (!values) {
      throw new Error("addRecord: 'values' payload is required for adding a record.");
    }
    return await executePayload(
      endpoint,
      requestName,
      {
        store,
        requestType: type,
        payloadType: 'values',
        payloads: values,
        excludeKeys,
        config
      }
    )
  }


  async function deleteRecord(endpoint, requestName, { store = {}, conditions, config } = {}) {
    if (!conditions) {
      throw new Error("deleteRecord: 'conditions' payload is required for deleting records.");
    }
    return await executePayload(
      endpoint,
      requestName,
      {
        store,
        requestType: 'delete',
        payloadType: 'conditions',
        payloads: conditions,
        config
      }
    )
  }


  async function updateRecord(endpoint, requestName, { store = {}, values, conditions,type='update', excludeKeys, config } = {}) {
    if (!values || !conditions) {
      throw new Error("updateRecord: Both 'values' and 'conditions' payloads are required for updating records.");
    }
    return await executePayload(
      endpoint,
      requestName,
      {
        store,
        requestType: type,
        payloadType: 'values',
        payloads: values,
        conditions: conditions,
        excludeKeys,
        config
      }
    )
  }


  async function customRequest(endpoint, requestName, requestType, {
    store = {},
    payloads = {},
    payloadType = 'values',
    conditions = null,
    excludeKeys = null,
    config = null
  } = {}) {
    if (!requestType) {
      throw new Error("customRequest: 'requestType' is required.");
    }
    return await executePayload(
      endpoint,
      requestName,
      {
        store,
        requestType,
        payloadType,
        payloads,
        conditions,
        excludeKeys,
        config
      }
    )
  }

  return {
    getAllRecords,
    getRecords,
    getRecord,
    addRecord,
    deleteRecord,
    updateRecord,
    customRequest,
  }
}
